import React from 'react';
import PropTypes from 'prop-types';
import { useUserContext } from '@fff-web/fff-utilities';

import CouponSelector from '../../Upgrade/CouponSelector';
import { Plans, taxTextsByCountry } from '../../constants';
import './styles.scss';
import usePriceCalculator from '../../../hooks/usePriceCalculator';
import useReactivateContent from '../../../hooks/useReactivateContent';
import useSubscriptionPlanPrices from '../../../hooks/useSubscriptionPlanPrices';

const Coupons = ({
  flags,
  membership,
  couponsApplied,
  couponError,
  handleRemoveCoupon,
  couponCode,
  handleApplyCoupon,
  couponDiscount,
}) => {
  const { getContentKey } = useReactivateContent();
  const { annualPrice, seasonalPrice } = useSubscriptionPlanPrices()
  const planKey = membership === Plans.SEASONAL ? 'seasonalPlan' : 'annualPlan';
  const printPrice = () => {
    if (planKey === 'seasonalPlan') return seasonalPrice;
    return annualPrice;
  }
  const { shipping, tax, total } = usePriceCalculator(membership, printPrice(), couponDiscount);
  const { userInfo } = useUserContext();
  const country = userInfo && userInfo.user ? userInfo.user.shippingCountry : '';

  return (
    <section className="coupons" data-testid="coupons">
      <div className="coupon-divider" style={{ margin: '0 0 9px 0' }} />
      <div className="subscription-container">
        <div className="fee">
          <h4>
            {getContentKey(
              `${planKey}.priceDetail.subscription.description`,
              planKey === 'seasonalPlan' ? 'Seasonal Subscription' : 'Annual Subscription',
            )}
          </h4>
          <span>{printPrice()}</span>
        </div>
        <span className="coupons-text">
          {getContentKey(
            `${planKey}.priceDetail.subscription.detail`,
            '1st Box',
          )}
        </span>
      </div>
      <div className="coupon-divider" style={{ margin: '7px 0 11px 0' }} />
      <CouponSelector
        plan={membership}
        onApplyCoupon={handleApplyCoupon}
        onRemoveCoupon={handleRemoveCoupon}
        initialCouponCode={couponCode}
        error={couponError}
        couponsApplied={couponsApplied}
      />
      <div className="tax">
        <span className="coupons-text">
          {getContentKey(
            `${planKey}.priceDetail.promo.description`,
            'Promo Code',
          )}

        </span>
        <span className="coupons-highlight-text">
          {couponDiscount}
        </span>
      </div>
      <div className="shipping">
        <span className="coupons-text">
          {getContentKey(
            `${planKey}.priceDetail.shipping.description`,
            'Shipping*',
          )}
        </span>
        <span className="coupons-highlight-text">
          {shipping}
        </span>
      </div>
      <div className="tax">
        <span className="coupons-text">{taxTextsByCountry(country).description}</span>
        <span className="coupons-highlight-text">
          {tax}
        </span>
      </div>
      <div className="total">
        <span className="coupons-text">{getContentKey(`${planKey}.priceDetail.total.description`, 'Total')}</span>
        <span className="coupons-highlight-text">
          {total}
        </span>
      </div>
    </section>
  );
};

Coupons.defaultProps = {
  membership: '',
};

Coupons.propTypes = {
  membership: PropTypes.string,
};

Coupons.displayName = 'Coupons';

export default Coupons;
